{
  "white": "#fff",
  "black": "#222",
  "deepBlack": "#000",
  "blue": "#107EAB",
  "blueActive": "#0E688B",
  "lightBlue": "#E2F7FF",
  "darkBlue": "#005379",
  "darkBlueActive": "#003146",
  "lightSilver": "#f8f8f8",
  "mediumSilver": "#d2d2d2",
  "silver": "#f1f1f1",
  "darkSilver": "#979797",
  "lightGray": "#555",
  "darkGray": "#424242",
  "red": "#e5053a",
  "orange": "#F9A21A",
  "gray": "#555",
  "greenSuccess": "#96BA3C",
  "yellow": "#F1C40F",
  "lightYellow": "#FDEFB4",
  "fudisRed": "#B83C2E",
  "lightRed": "#F4DADA",
  "chartHeight": "290px",
  "maxBarWidth": "50px",
  "baseFont": "'Open Sans', Helvetica, Arial, sans-serif"
}
